module.exports = "<div >\n    <div class=\"flex filter-container filtrt-audit\">\n        <div class=\"filter-title\">Filters</div>\n        <div class=\"dbm dbm-back-icon\" (click)=\"isCollapsed = !isCollapsed; getDataProjectsWithDeployStatus()\"\n             [ngClass]=\"isCollapsed? 'expanded': 'collapsed'\"></div>\n    </div>\n\n    <reports-audit-filter *ngIf=\"!isCollapsed\" (filter)=\"filter($event)\"></reports-audit-filter>\n    <reports-audit-data [data]=\"tableData\"></reports-audit-data>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/reports/report-details-an7/reports-audit.component.html
// module id = 1830
// module chunks = 0